import secureLog from './secureLogger';

/**
 * Secure configuration utility that prevents exposing sensitive config values
 */
const secureConfig = {
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || '',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
    functionsUrl: process.env.REACT_APP_SUPABASE_FUNCTIONS_URL || '',
  },
  mapbox: {
    accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '',
  },
  analytics: {
    fbPixelId: process.env.REACT_APP_FB_PIXEL_ID || '',
    googleAnalyticsId: process.env.REACT_APP_GA_ID || '',
    googleTagManagerId: process.env.REACT_APP_GTM_ID || '',
  },
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
    clientId: process.env.REACT_APP_API_CLIENT_ID || '',
  }
};

// Log config structure in development, not the actual values
if (process.env.NODE_ENV === 'development') {
  secureLog.debug('Config structure:', Object.keys(secureConfig));
}

/**
 * Gets a configuration value safely
 * @param {string} path - Dot notation path to config value (e.g. 'supabase.url')
 * @returns {any} The configuration value or empty string if not found
 */
export const getConfig = (path) => {
  const parts = path.split('.');
  let current = secureConfig;
  
  for (const part of parts) {
    if (current && typeof current === 'object' && part in current) {
      current = current[part];
    } else {
      return '';
    }
  }
  
  return current;
};

/**
 * Checks if a configuration value exists and is not empty
 * @param {string} path - Dot notation path to config value
 * @returns {boolean} True if the config exists and is not empty
 */
export const hasConfig = (path) => {
  const value = getConfig(path);
  return value !== undefined && value !== null && value !== '';
};

/**
 * Gets a masked version of a configuration value for debugging
 * Shows only the first and last characters, masking the rest
 * @param {string} path - Dot notation path to config value
 * @returns {string} Masked configuration value
 */
export const getMaskedConfig = (path) => {
  const value = getConfig(path);
  if (typeof value !== 'string' || value.length < 4) {
    return value ? '[SET]' : '[NOT SET]';
  }
  
  return `${value.substring(0, 2)}...${value.substring(value.length - 2)}`;
};

export default {
  getConfig,
  hasConfig,
  getMaskedConfig
}; 